import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart-sharp",
  "use": "icon-cart-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-cart-sharp\"><title>Cart</title><circle cx=\"176\" cy=\"416\" r=\"32\" /><circle cx=\"400\" cy=\"416\" r=\"32\" /><path d=\"M167.78 304h261.34l38.4-192H133.89l-8.47-48H32v32h66.58l48 272H432v-32H173.42l-5.64-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol